module.exports = __webpack_public_path__ + "media/images/b_star-a9ff1e6637ee1cf9eadafd94f6fbb93e.svg";